import './App.css';
import React, { Suspense } from 'react';
import {
  createBrowserRouter,
  RouterProvider,
  Navigate
} from "react-router-dom";

import { UserProvider } from './Contexts/UserContext';

import Root from './Components/Root';
import Login from './Components/Login';
import Home from './Components/Home';
import Games from './Components/Games';
import Game from './Components/Game';

import IsLoggedIn from './Components/IsLoggedIn';
import ErrorPage from './error-page';

const router = (isLoggedIn) => createBrowserRouter([
  {
    path: "/",
    element: isLoggedIn ? <Root/> : <Navigate to="/login" />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/games/:cat",
        element: <Games/>
      },
      {
        path: "/game/",
        element: <Game />,
      },
    ],
  },
  {
    path: "/login",
    element: isLoggedIn ? <Navigate to="/" /> : <Login/>,
  },
]);

function App() {

  const authState = IsLoggedIn();

  if(authState === null){
    return(
      <Suspense fallback="loading">
      </Suspense>
    )
  }

  return (
    <Suspense fallback="loading">
      <UserProvider>
        <RouterProvider router={router(authState)} />
      </UserProvider>
    </Suspense>
  );
}

export default App;
